import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import getRoutesSidebar from "./permissions/routesSidebar";
import RightGuard from "./components/general/RightGuard";

import AuthContext from "./context/AuthContext";

import axiosConfig from "./utils/axiosConfig";

import ReactGA from "react-ga4";
ReactGA.initialize("G-39WWE523LZ");

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
      connected: null,
      id: null,
      companyId: null,
      name: null,
      admin: null,
      interfaceColor: null,
      // Empty, not a hand-written list of flags: an unknown key reads as
      // `undefined` -> falsy -> fail-closed. The real blob arrives with the token.
      access: { clickable: {}, displayed: {} },
      picture: null,
    };
  }

  componentDidMount() {
    this.checkAuth();
    this.intervalToken = setInterval(() => {
      this.checkAuth();
    }, 30 * 60 * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalToken);
  }

  checkAuth = () => {
    if (!document.location.href.includes("signout")) {
      axiosConfig("/auth/refresh-token").then((res) => {
        if (res.data.success === true) {
          const oldState = this.state;
          const newState = {
            isReady: true,
            connected: true,
            id: res.data.data.id,
            companyId: res.data.data.companyId,
            name: res.data.data.name,
            admin: res.data.data.admin,
            interfaceColor: res.data.data.interfaceColor,
            access: res.data.data.access,
            picture: res.data.data.picture,
          };
          if (JSON.stringify(oldState) !== JSON.stringify(newState)) {
            this.setState(newState);
          }
        } else {
          const oldState = this.state;
          const newState = {
            isReady: true,
            connected: false,
            id: null,
            companyId: null,
            name: null,
            admin: null,
            interfaceColor: null,
            access: { clickable: {}, displayed: {} },
            picture: null,
          };
          if (JSON.stringify(oldState) !== JSON.stringify(newState)) {
            this.setState(newState);
          }
        }
      });
    } else {
      this.setState({ connected: false });
    }
  };

  // Recomputed only when the rights actually change. Two reasons this is a memo and
  // not state: the ui-kit Sidebar mutates the array it receives (it writes `active`
  // onto the entries), and checkAuth diffs the whole state with JSON.stringify — a
  // mutated sidebar in state would make that diff always true, so every 30-minute
  // token refresh would setState and collapse the user's open dropdown.
  getPages = () => {
    const key = JSON.stringify([this.state.admin, this.state.companyId, this.state.access]);

    if (this.pagesKey !== key) {
      this.pagesKey = key;
      this.pages = getRoutesSidebar({
        admin: this.state.admin,
        companyId: this.state.companyId,
        access: this.state.access,
      });
    }

    return this.pages;
  };

  render() {
    if (!this.state.isReady) {
      return <></>;
    }

    const { routes, sidebar } = this.getPages();

    return (
      <AuthContext.Provider
        value={{
          id: this.state.id,
          companyId: this.state.companyId,
          name: this.state.name,
          admin: this.state.admin,
          picture: this.state.picture,
          access: this.state.access,
          interfaceColor: this.state.interfaceColor,
        }}
      >
        <style>
          {`
          *{
            ${
              this.state.interfaceColor
                ? `--primary-color:${this.state.interfaceColor.primary} !important;`
                : ""
            }
            ${
              this.state.interfaceColor
                ? `--secondary-color:${this.state.interfaceColor.secondary} !important;`
                : ""
            }
          }
          `}
        </style>
        <Router basename={process.env.REACT_APP_BASENAME || ""}>
          <Switch>
            {routes.map((route, index) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  render={(props) => {
                    return (
                      <route.layout
                        {...props}
                        connected={this.state.connected}
                        companyId={this.state.companyId}
                        admin={this.state.admin}
                        sidebar={sidebar}
                      >
                        <RightGuard
                          right={route.right}
                          adminOnly={route.adminOnly}
                          superAdmin={route.superAdmin}
                          teaserTitle={route.teaserTitle}
                          contactPage={route.contactPage}
                        >
                          <route.component {...props} />
                        </RightGuard>
                      </route.layout>
                    );
                  }}
                />
              );
            })}
          </Switch>
        </Router>
      </AuthContext.Provider>
    );
  }
}
